// Vuetify 3 plugin configured with the ThinkSpatial brand system.
// Requirements: 8.1 (brand colours), 8.2 (red-orange #e7511e as primary/accent
// for CTAs), 8.4 (Lato primary font), 8.6 (light-themed treatment), 13.1 (Vuetify 3).
import 'vuetify/styles'
// Material Design Icons font — required for the class-based `mdi` icon set so
// icon-only controls (e.g. the Project_List edit/reorder/delete actions and the
// "Add project" button) render a visible glyph. The @mdi/font package is a
// declared dependency; without this import Vuetify's default `mdi` set has no
// font to draw from and every icon renders empty.
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

// ThinkSpatial brand colours (carried over verbatim from the Vuetify 2 theme).
const brand = {
  burntOrange: '#f29400', // burnt orange
  redOrange: '#e7511e', // red-orange — primary action/accent colour
  brown: '#41281b', // brand brown
  textPrimary: '#4a4a4a', // neutral primary text
  textSecondary: '#929292', // neutral secondary text
}

// Light theme: white/neutral backgrounds with brand-colour accents (Req 8.6).
const thinkspatialLight = {
  dark: false,
  colors: {
    // Light-themed surfaces and backgrounds (Req 8.6).
    background: '#ffffff',
    surface: '#ffffff',
    'surface-variant': brand.brown,
    'on-surface-variant': '#ffffff',

    // Red-orange drives primary actions and CTAs (Req 8.2).
    primary: brand.redOrange,
    accent: brand.redOrange,

    // Remaining brand palette (Req 8.1).
    secondary: brand.burntOrange,
    'brand-burnt-orange': brand.burntOrange,
    'brand-red-orange': brand.redOrange,
    'brand-brown': brand.brown,
    'text-primary': brand.textPrimary,
    'text-secondary': brand.textSecondary,

    // Neutral on-colour text for readable contrast.
    'on-background': brand.textPrimary,
    'on-surface': brand.textPrimary,
    'on-primary': '#ffffff',

    // Standard semantic colours.
    error: '#e7511e',
    info: '#929292',
    success: '#4caf50',
    warning: '#f29400',
  },
  // Lato is the primary font (Req 8.4); the family is also imported globally
  // in client/src/assets/style.scss for body and heading text.
  variables: {
    'body-font-family': "'Lato', Helvetica, Arial, sans-serif",
  },
}

export default createVuetify({
  // Use the Material Design Icons font set (backed by the @mdi/font CSS
  // imported above) so all `mdi-*` icons across the app render.
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  theme: {
    defaultTheme: 'thinkspatialLight',
    themes: {
      thinkspatialLight,
    },
  },
})
